// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Chips_wrapper__YXY_S","range":"Chips_range__reC3Y","button":"Chips_button__XGOjp","icon":"Chips_icon__7Cyze"};